import MovieCard from '@/components/base/MovieCard';
import { movies, type Movie } from '@/mocks/movies';

const hotMovies = [...movies].sort((a, b) => b.views - a.views).slice(0, 8);

export default function PopularMovies() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-50">
            热门排行
          </h2>
          <p className="text-xs text-foreground-500 mt-1">本周最受欢迎的电影</p>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
        {hotMovies.map((movie, index) => (
          <div key={movie.id} className="relative">
            <div className="absolute -top-1 -left-1 z-10 w-7 h-7 md:w-8 md:h-8 rounded-lg bg-primary-500 flex items-center justify-center">
              <span className="text-background-950 text-xs md:text-sm font-bold">{index + 1}</span>
            </div>
            <MovieCard movie={movie} />
          </div>
        ))}
      </div>
    </section>
  );
}